import { createContext, useContext, useState } from "react";

const STORAGE_KEY = "elva.scenarioMode";

// App-level Scenario Mode (Build 7.5A): when ON, company-dependent financial views
// show Scenario Outcome (Official + active scenarios) via the /scenario-outcome/*
// endpoints. Default is OFF — operational pages always show the Official Forecast
// unless the user explicitly enters Scenario Mode (§28-30).
const ScenarioModeContext = createContext(null);

export function ScenarioModeProvider({ children }) {
  const [scenarioMode, setScenarioModeState] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) === "1";
    } catch {
      return false;
    }
  });

  const setScenarioMode = (on) => {
    setScenarioModeState(!!on);
    try {
      if (on) localStorage.setItem(STORAGE_KEY, "1");
      else localStorage.removeItem(STORAGE_KEY);
    } catch {
      // storage unavailable — keep in-memory state only
    }
  };

  return (
    <ScenarioModeContext.Provider value={{ scenarioMode, setScenarioMode }}>
      {children}
    </ScenarioModeContext.Provider>
  );
}

export function useScenarioMode() {
  const ctx = useContext(ScenarioModeContext);
  if (!ctx) throw new Error("useScenarioMode must be used within ScenarioModeProvider");
  return ctx;
}
